import { useField, FieldHookConfig } from "formik";
import { styled } from "@mui/material";
import { FC, ReactElement } from "react";

interface ComponentProps {
  label?: string;
  type?: string;
  marginRight?: string;
  width?: string;
  defaultValue?: any;
  icon?: string;
}

const Input: FC<ComponentProps & FieldHookConfig<string> & any> = (
  props
): ReactElement => {
  const [field, meta] = useField(props);
  return (
    <InputWrapper aria-label="form input container">
      <Label htmlFor={props.id || props.name}>{props.label}</Label>
      {props.type === "tel" ? (
        <StyledNumber
          {...props}
          {...field}
          type={props.type || "text"}
          allowNegative={
            (props.type === "tel" || props.type === "date") && false
          }
          allowLeadingZeros={
            (props.type === "tel" || props.type === "date") && true
          }
        />
      ) : (
        <StyledInput
          {...props}
          {...field}
          type={props.type}
          placeholder={props.placeholder}
        />
      )}
      {props.icon ? <StyledImg src={`${props.icon}`} /> : undefined}
      {
        /**validation error message */
        meta.touched && meta.error ? (
          <ErrorMessage>
            <Span>&#42;</Span>
            {meta.error}
          </ErrorMessage>
        ) : null
      }
    </InputWrapper>
  );
};

export default Input;

export const StyledInput = styled("input")<ComponentProps>`
  flex: 1 1 100%;
  padding: 1rem 1.5rem;
  font-size: 14px;
  height: 3.6rem;
  box-shadow: 0 0.7rem 0.9rem -3rem rgba(70, 70, 70, 0.06);
  color: var(--color-black-default);
  transition: all 0.5s ease-out;
  transform-origin: top left;
  border: 0.1rem solid #E1E1E1;
  border-radius: 0.4rem;

  &:focus {
    outline: none;
    border: 0.1rem solid var(--color-primary);
    background: rgb(246, 251, 243);
  }

  &:disabled {
    background-color: #dadada;
  }
`;

export const StyledNumber = styled<any>("NumericFormat")`
  flex: 1 1 100%;
  padding: 1.4rem 2.4rem;
  font-size: 1.5rem;
  height: 3.6rem;
  width: 100%;
  background: #fdfdfd;
  border: 0.1rem solid #dadada;
  box-shadow: 0 0.7rem 0.9rem -3rem rgba(70, 70, 70, 0.06);
  color: var(--color-black-default);
  transition: all 0.5s ease-out;
  transform-origin: top left;

  &:focus {
    outline: none;
    border: 0.1rem solid var(--color-primary);
  }

  &:disabled {
    background-color: #dadada;
  }
`;

export const InputWrapper = styled("div")<ComponentProps>`
  display: flex;
  flex-direction: column;
  max-width: ${({ width }) => (width ? width : "100%")};
  width: 100%;
  border-radius: 0.4rem;
  position: relative;
`;

 export const Label = styled("label")`
  color:#333333;
  padding-bottom: 5px;
  padding-top: 20px;
  flex: 1 1 100%;
  color: #232323;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 00.2rem;


  // color: #4a4a4a;
	// padding-bottom: 0.7rem;
	// flex: 1 1 100%;
	// color: var(--color-black-default);
	// font-style: normal;
	// font-weight: normal;
	// font-size: 1.6rem;
	// letter-spacing: 00.2rem;
	// text-transform: capitalize;
`;

export const StyledImg = styled("img")`
  position: absolute;
  position: absolute;
  top: 4rem;
  left: 32rem;
`;

export const ErrorMessage = styled("menu")`
  color:red;
  font-size: 12px;
  display: flex;
  padding-inline-start: 0px;
`;

export const Span = styled("span")`
  position: relative;
  top: 5px;
`;
